import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiagramWrapperComponent } from './components/diagram-wrapper/diagram-wrapper.component';
import {
  RappiderAlertModule, RappiderButtonModule,
  RappiderDropdownMenuModule,
  RappiderEditFormModule,
  RappiderHeadingModule, RappiderIconModule,
  RappiderMenuModule,
  RappiderModalModule,
  RappiderSliderModule
} from '@rappider/rappider-components';
import { DiagramToolbarComponent } from './components/diagram-toolbar/diagram-toolbar.component';
import { WorkflowEventModule } from '@rappider/workflow-event';
import { WorkflowStepFunctionModule } from '@rappider/workflow-step-function';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { CommentModule } from '@rappider/comment';
import { AngularSplitModule } from 'angular-split';
import { RappiderButtonListModule } from '@rappider/rappider-components';
import { BpmnEditorComponent } from './components/bpmn-editor/bpmn-editor.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ɵEmptyOutletComponent } from "@angular/router";
import { CustomFunctionModule } from 'libs/custom-function/src/lib/custom-function.module';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { GraphService } from './services/graph.service';
import { DiagramNodeToolbarComponent } from './components/diagram-node-toolbar/diagram-node-toolbar.component';

@NgModule({
  imports: [
    CommonModule,
    RappiderButtonModule,
    RappiderIconModule,
    WorkflowEventModule,
    WorkflowStepFunctionModule,
    RappiderHeadingModule,
    RappiderIconModule,
    NzDropDownModule,
    TranslateModule,
    RappiderModalModule,
    NzCollapseModule,
    NzButtonModule,
    RappiderAlertModule,
    CommentModule,
    RappiderButtonListModule,
    AngularSplitModule,
    BpmnEditorComponent,
    RappiderMenuModule,
    RappiderEditFormModule,
    RappiderDropdownMenuModule,
    RappiderSliderModule,
    ɵEmptyOutletComponent,
    FormsModule,
    ReactiveFormsModule,
    CustomFunctionModule,
    NzToolTipModule,
    DiagramNodeToolbarComponent,
    NzSelectModule
  ],
  providers: [
    GraphService
  ],
  declarations: [
    DiagramWrapperComponent,
    DiagramToolbarComponent,
  ],
  exports: [
    DiagramWrapperComponent
  ]
})
export class WorkflowDiagramForComponentsModule { }
